module.exports = __webpack_public_path__ + "img/bg3.cb52c81e.jpg";